import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    postFamilyData (data) {
        return httpService.post(ApiEndpoints.get('families_to_accept_internal'), data);
    },
    postFamilyDataWithConvert (data) {
        return httpService.post(ApiEndpoints.get('families_to_accept_internal_with_convert'), data);
    },
    getFamilyDuplicate (data) {
        return httpService.get(ApiEndpoints.get('family_duplicate'), {
            params: data
        });
    },
    postFamilyToAccept (data) {
        return httpService.post(ApiEndpoints.get('familiesToAccept'), data);
    },
    getFamilies (data) {
        return httpService.post(
            ApiEndpoints.getWithURLParams('families_not_attributed', data.urlParams),
            data.payload
        );
    },
    getMyFamilies (data) {
        return httpService.post(
            ApiEndpoints.getWithURLParams('my_families', data.urlParams),
            data.payload
        );
    },
    getFamiliesToAccept (data) {
        return httpService.post(ApiEndpoints.get('families_to_accept_filter'), {
            limit: data.limit,
            offset: data.offset,
            external: data.external,
            provinces: data.provinces,
            order: data.order
        });
    },
    deleteFamilyToAccept (data) {
        return httpService.delete(ApiEndpoints.get('familiesToAccept', { familyId: data }));
    },
    convertFamilyToAccept (data) {
        return httpService.post(ApiEndpoints.get('convertFamilyToAccept', { family_id: data }));
    },
    getFamilyById (familyId, endpointLabel) {
        return httpService.get(ApiEndpoints.get(endpointLabel, { familyId }));
    },
    getSimilarFamilies (data) {
        return httpService.get(ApiEndpoints.get('similar_families'), {
            params: data
        });
    },
    editFamilyData (data) {
        if (data.privileged) {
            return httpService.put(
                ApiEndpoints.get('family', {
                    familyId: data.id,
                    privileged: 'privileged'
                }),
                data.data
            );
        }
        return httpService.put(ApiEndpoints.get('family', { familyId: data.id }), data.data);
    },
    overwriteFamilyData (data) {
        return httpService.post(
            ApiEndpoints.get('overwrite_similar_family', { familyId: data.id }),
            data.data
        );
    },
    excludeFamily (data) {
        return httpService.put(
            ApiEndpoints.get('family_exclude', { familyEditionId: data.id }),
            data.data
        );
    },
    includeFamily (data) {
        return httpService.put(ApiEndpoints.get('family_include', { familyEditionId: data.id }), {
            description: data.data
        });
    },
    putChangeRegion (data) {
        return httpService.put(
            ApiEndpoints.get('change_wio_structs', {
                familyEditionId: data.familyEditionId,
                wioId: data.wioId
            })
        );
    },
    revokeFamily (familyEditionId) {
        return httpService.put(ApiEndpoints.get('revoke_publication', { familyEditionId }));
    },
    verifiedConsent (familyToAcceptId) {
        return httpService.put(ApiEndpoints.get('verified_consent', { familyToAcceptId }));
    },
    getFamiliesToDecide () {
        return httpService.get(ApiEndpoints.get('families_to_decide'));
    },
    connectFamily (data) {
        return httpService.put(ApiEndpoints.get('connect_family', data));
    },
    connectFamilyDuplicate (data) {
        return httpService.put(ApiEndpoints.get('connect_family_duplicate', data));
    },
    checkPreviousEditions (data) {
        return httpService.get(ApiEndpoints.get('similar_previous_edition', { familyId: data }));
    },
    markAsChecked (data) {
        return httpService.put(ApiEndpoints.get('family_mark_as_checked', { familyId: data }));
    },
    removeConsent (data) {
        const endpointLabel = data.isPrivileged
            ? 'initial_consent_file_privileged'
            : 'initial_consent_file';
        return httpService.delete(
            ApiEndpoints.get(endpointLabel, { familyEditionId: data.familyId, uri: data.uri })
        );
    },
    replaceConsent (data, formData) {
        const endpointLabel = data.isPrivileged
            ? 'initial_consent_file_privileged'
            : 'initial_consent_file';
        return httpService.post(
            ApiEndpoints.get(endpointLabel, { familyEditionId: data.familyId, uri: data.uri }),
            formData
        );
    },
    addConsent (data, formData) {
        const endpointLabel = data.isPrivileged
            ? 'initial_consent_file_privileged'
            : 'initial_consent_file';
        return httpService.post(
            ApiEndpoints.get(endpointLabel, { familyEditionId: data.familyId }),
            formData
        );
    },
    editFamilyDescription (data) {
        return httpService.put(
            ApiEndpoints.get('edit_family_description', { familyEditionId: data.familyEditionId }),
            { description: data.data }
        );
    }
};
